import {TrackingClientStateHolder} from '../helpers/clientState';

export interface ABTestGroupAssignmentParams {
  testName: string;
  testVariation: string;
}

export const trackABTestGroupAssignment =
  ({testName, testVariation}: ABTestGroupAssignmentParams) =>
  (clientState: TrackingClientStateHolder) => {
    const {currentPage} = clientState.getCurrent();
    const event = {
      event: 'abtest',
      action: testName,
      label: testVariation,
      value: null,
      content_name: currentPage?.page?.path || '',
      page_type: currentPage?.page?.type || '',
      page_type_id:
        currentPage?.type === 'detailed' ? `${currentPage.page?.id || ''}` : '',
    };

    return event;
  };
